import React from 'react';

/**
 * Top-down rink split into the three lanes of the 3-Lane Lesson.
 * Pack convention: Lane 1 along the door-side boards, Lane 2 in the center,
 * Lane 3 along the far boards. Edge tracings as thin curves, cones as triangles.
 */
type RinkLanesProps = {
  className?: string;
  labels?: boolean;
  title?: string;
};
const lanes = [{
  id: 'L3',
  name: 'Advanced',
  y: 22,
  color: '#E4586B'
}, {
  id: 'L2',
  name: 'Developing',
  y: 74,
  color: '#F2B33D'
}, {
  id: 'L1',
  name: 'Beginner',
  y: 126,
  color: '#3DBE9A'
}];
export function RinkLanes({
  className = '',
  labels = true,
  title = 'Rink seen from above, split into three lanes: Lane 1 Beginner by the door side, Lane 2 Developing in the center, Lane 3 Advanced along the far boards'
}: RinkLanesProps) {
  return <svg viewBox="0 0 400 190" role="img" aria-label={title} className={`w-full h-auto ${className}`} data-id="element-379" data-mp="3sd9ls9dj60eb">
      <rect x="4" y="12" width="392" height="166" rx="48" fill="#F7FAFC" stroke="#9CC9E3" strokeWidth="3" data-id="element-380" data-mp="165ldxbw5cev" />
      {lanes.map(lane => <g key={lane.id} data-id="element-381" data-mp="1kj7kzggwhe5">
          <rect x="8" y={lane.y} width="384" height="42" fill={lane.color} opacity="0.16" data-id="element-382" data-mp="3srltbbdjdvgz" />
          {/* edge tracing: a serpentine of edges along the lane */}
          <path d={`M 60 ${lane.y + 30} C 95 ${lane.y + 4}, 130 ${lane.y + 4}, 165 ${lane.y + 21} S 235 ${lane.y + 38}, 270 ${lane.y + 21} S 320 ${lane.y + 6}, 345 ${lane.y + 14}`} fill="none" stroke={lane.color} strokeWidth="2" strokeLinecap="round" data-id="element-383" data-mp="3nzas857283mu" />
          <path d={`M 345 ${lane.y + 14} l -9 -4 l 2 9 z`} fill={lane.color} data-id="element-384" data-mp="3a3gxcq34fesq" />
          {[110, 200, 290].map(x => <path key={x} d={`M ${x} ${lane.y + 36} l 5 -9 l 5 9 z`} fill="#1E3A5F" opacity="0.55" data-id="element-385" data-mp="3036jd399i3ci" />)}
          {labels && <g data-id="element-386" data-mp="139d5yft064qc">
              <rect x="18" y={lane.y + 11} width="30" height="20" rx="10" fill={lane.color} data-id="element-387" data-mp="139v8tva67h78" />
              <text x="33" y={lane.y + 25} textAnchor="middle" fontFamily="Montserrat, sans-serif" fontWeight="700" fontSize="11" fill="#132840" data-id="element-388" data-mp="yc36067zmao9">
                {lane.id}
              </text>
            </g>}
        </g>)}
      <line x1="8" y1="70" x2="392" y2="70" stroke="#9CC9E3" strokeWidth="1.5" strokeDasharray="5 5" data-id="element-389" data-mp="2itm6tpowbzhm" />
      <line x1="8" y1="122" x2="392" y2="122" stroke="#9CC9E3" strokeWidth="1.5" strokeDasharray="5 5" data-id="element-390" data-mp="2nsfjjfwczmgq" />
      {/* door on the Lane 1 side */}
      <rect x="180" y="174" width="40" height="8" rx="2" fill="#1E3A5F" data-id="element-391" data-mp="3bjkx1oetu2nv" />
    </svg>;
}